import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import useIsMobile from "../../hooks/useIsMobile";
import SocialIcon from "../common/SocialIcon";
import { BRAND, SOCIAL } from "../../data/constants";
import { colors, fonts, btnGhost, maxW } from "../../styles/theme";

const FOOTER_COMPANY = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Portfolio", path: "/portfolio" },
  { label: "Blog", path: "/blog" },
];

const FOOTER_PROGRAMS = [
  { label: "Internship", path: "/internship" },
  { label: "Careers", path: "/careers" },
  { label: "Frontend Track", path: "/internship" },
  { label: "Cloud Track", path: "/internship" },
  { label: "Design Track", path: "/internship" },
];

export default function Footer() {
  const mob = useIsMobile();
  return (
    <footer style={{ background: colors.ink, padding: mob ? "52px 6% 26px" : "76px 6% 34px" }}>
      <div style={{ ...maxW }}>
        <div style={{ display: "grid", gridTemplateColumns: mob ? "1fr 1fr" : "1.6fr 1fr 1fr 1fr", gap: mob ? 30 : 44, marginBottom: 52 }}>

          <div style={{ gridColumn: mob ? "1 / -1" : undefined }}>
            <Link to="/" style={{ ...btnGhost, display: "inline-block", marginBottom: 16, textDecoration: "none" }}>
              <span style={{ fontFamily: fonts.display, fontStyle: "italic", fontWeight: 500, fontSize: 26, color: colors.cream }}>Charith</span>
            </Link>
            <p style={{ color: colors.creamDim, fontFamily: fonts.body, fontSize: 13, lineHeight: 1.8, maxWidth: 240 }}>
              A full-service digital agency — web, cloud, mobile and design, built for growth.
            </p>
            <div style={{ marginTop: 20, display: "flex", gap: 10 }}>
              {SOCIAL.map((s) => (
                <motion.button
                  key={s.label}
                  whileHover={{ borderColor: colors.cream }}
                  onClick={() => window.open(s.href, "_blank")}
                  style={{ width: 36, height: 36, borderRadius: 3, background: "transparent", border: `1px solid ${colors.creamBorder}`, display: "flex", alignItems: "center", justifyContent: "center", color: colors.creamDim, cursor: "pointer" }}
                >
                  <SocialIcon path={s.path} size={14} />
                </motion.button>
              ))}
            </div>
          </div>

          <div>
            <h4 style={{ fontFamily: fonts.body, fontWeight: 700, fontSize: 11, color: colors.cream, letterSpacing: ".14em", marginBottom: 18, textTransform: "uppercase" }}>Company</h4>
            <div style={{ display: "flex", flexDirection: "column", gap: 11 }}>
              {FOOTER_COMPANY.map((l) => (
                <Link key={l.label} to={l.path} style={{ ...btnGhost, color: colors.creamDim, fontFamily: fonts.body, fontSize: 13.5, textAlign: "left", textDecoration: "none" }}>{l.label}</Link>
              ))}
            </div>
          </div>

          <div>
            <h4 style={{ fontFamily: fonts.body, fontWeight: 700, fontSize: 11, color: colors.cream, letterSpacing: ".14em", marginBottom: 18, textTransform: "uppercase" }}>Programs</h4>
            <div style={{ display: "flex", flexDirection: "column", gap: 11 }}>
              {FOOTER_PROGRAMS.map((l, i) => (
                <Link key={l.label + i} to={l.path} style={{ ...btnGhost, color: colors.creamDim, fontFamily: fonts.body, fontSize: 13.5, textAlign: "left", textDecoration: "none" }}>{l.label}</Link>
              ))}
            </div>
          </div>

          <div>
            <h4 style={{ fontFamily: fonts.body, fontWeight: 700, fontSize: 11, color: colors.cream, letterSpacing: ".14em", marginBottom: 18, textTransform: "uppercase" }}>Contact</h4>
            <div style={{ display: "flex", flexDirection: "column", gap: 11 }}>
              <button onClick={() => window.open(`mailto:${BRAND.email}`, "_self")} style={{ ...btnGhost, color: colors.creamDim, fontFamily: fonts.body, fontSize: 13, textAlign: "left", wordBreak: "break-all", lineHeight: 1.5 }}>{BRAND.email}</button>
              <a href={BRAND.linkedin} target="_blank" rel="noreferrer" style={{ color: colors.creamDim, fontFamily: fonts.body, fontSize: 13.5, textDecoration: "none" }}>LinkedIn</a>
            </div>
          </div>
        </div>

        <div style={{ borderTop: `1px solid rgba(255,255,255,0.15)`, paddingTop: 22, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
          <p style={{ color: colors.creamFaint, fontFamily: fonts.body, fontSize: 12, margin: 0 }}>© 2026 Charith. All rights reserved.</p>
          <p style={{ color: colors.creamFaint, fontFamily: fonts.body, fontSize: 12, margin: 0 }}>{BRAND.tagline}</p>
        </div>
      </div>
    </footer>
  );
}
